
    import { Component, Vue, Inject, Prop } from "vue-property-decorator"
    import { VForm } from "@/app/common/types/v-form.type"
    import { NotificationDispatcher } from "@/app/common/services/notification-dispatcher.service"
    import validation from "@/app/common/helpers/validation"
    import { Consumer } from "@/app/identity"

    @Component
    export default class Goals extends Vue {
        formData = {
            payOffInFull: '',
            minimumPayOff: null as number | null,
            changesInCosts: '',
            minimumYearsLiving: null as number | null
        }
        @Inject() notificationDispatcher!: NotificationDispatcher
        consumer!: Consumer
        rules = validation
        @Prop({ default: () => ({}) }) readonly externalFormData!: any
        mounted() {
            this.formData = { ...this.formData, ...this.externalFormData }
        }
        get form(): VForm {
            return this.$refs.form as VForm
        }
        validate(): boolean {
            return this.form.validate()
        }
        goToPreviousStep() {
            this.$emit('changeStep', 5)
        }
        goToNextStep() {
            if (this.validate()) {
                this.formData = {
                    payOffInFull: this.formData.payOffInFull || '',
                    changesInCosts: this.formData.changesInCosts || '',
                    minimumPayOff: this.formData.minimumPayOff ?? 0,
                    minimumYearsLiving: this.formData.minimumYearsLiving ?? 0,
                }
                this.$emit('updateData', this.formData)
                this.$emit('changeStep', 7)
            }
        }
    }
